import { useApolloClient } from "@vue/apollo-composable";
import { handleError } from "@/services/AlertService";
import GetOrganisation from "../queries/GetOrganisation.graphql";

export function getOrganisationDetails(id: string) {
    const { client } = useApolloClient();
    return new Promise(async (resolve, reject) => {
        try {
            const result = await client.query({
                query: GetOrganisation,
                variables: {
                    id,
                },
            });

            // Check if we got an Organisation object back
            if (result.data.organisation && !result.data.organisation.message) {
                resolve(result.data.organisation);
                return;
            }
            if (result.data.organisation && result.data.organisation.message) {
                // Handle error case if needed
                reject(new Error(result.data.organisation.message));
                return;
            }

            resolve(null);
        } catch (error) {
            console.error(error);
            handleError(error);
            reject(error);
        }
    });
}
